import { Injectable } from '@angular/core';
import { HttpRequest, HttpResponse } from '@angular/common/http';

interface CacheEntry {
  response: HttpResponse<any>;
  timestamp: number;
  ttl: number;
}

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  private cache = new Map<string, CacheEntry>();
  private readonly DEFAULT_TTL = 300000; // 5 minutes

  get(req: HttpRequest<any>): HttpResponse<any> | null {
    const key = this.getKey(req);
    const entry = this.cache.get(key);
    
    if (!entry) return null;
    
    if (Date.now() - entry.timestamp > entry.ttl) {
      this.cache.delete(key);
      return null;
    }
    
    return entry.response;
  }

  put(req: HttpRequest<any>, response: HttpResponse<any>, ttl = this.DEFAULT_TTL): void {
    if (!this.isCacheable(req, response)) return;
    
    const key = this.getKey(req);
    this.cache.set(key, {
      response: response.clone(),
      timestamp: Date.now(),
      ttl
    });
  }

  clear(): void {
    this.cache.clear();
  }

  private getKey(req: HttpRequest<any>): string {
    return `${req.method}:${req.urlWithParams}`;
  }

  private isCacheable(req: HttpRequest<any>, response: HttpResponse<any>): boolean {
    return req.method === 'GET' && 
           response.status === 200 && 
           (req.url.includes('/assets/i18n/') || req.url.includes('/assets/'));
  }
}